/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesFolders.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Folder Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, November 19, 2018 - 06:07:58 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      11/19/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const FolderList = Loadable({
    loader: () => import('../containers/Folders/FolderListContainer'),
    loading: Loading,
});

export const FolderForm = Loadable({
    loader: () => import('../containers/Folders/FolderEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesFolders.js